export const FREE_CONVERSION_LIMIT = 3
